import React, { useState, useEffect, useMemo } from "react";
import FixedTable from "./fixedTable";
import { ChartsType, ICharts, tabType } from "@Types/kindSumReport";

interface IProps {
  charts: ChartsType;
  dataSource: ICharts["chartData"];
}

const ViewTestTab: React.FC<IProps> = ({ charts, dataSource }) => {
  const [active, setActive] = useState<number>(0);
  const [relationChartId, setId] = useState<number>(0);
  const data = useMemo(() => dataSource?.[0] ?? [], [dataSource]);

  const validateData = (data: any, key: number) => {
    if (data?.[key] && data?.[key]?.chartData && data?.[key]?.chartData.length !== 0) {
      return charts?.[key] as ICharts;
    }
    return false;
  };

  const tableData = useMemo(() => {
    return validateData(charts, relationChartId);
  }, [charts, relationChartId]);

  useEffect(() => {
    if (!!dataSource && dataSource.length !== 0 && dataSource[0]?.length !== 0) {
      setId(dataSource[0][0].relationChartId);
    }
  }, [dataSource]);

  useEffect(() => {}, []);

  return (
    <div className='flex flex-col relative'>
      <div className='flex border-0 border-b-1 border-solid border-[#EAEFFF]'>
        {data.map((item, index) => (
          <p
            className={`${active === index ? "text-[#fff] bg-[#3365FE]" : "text-[#333333] bg-[#fff]"} ${
              index === 0 ? "rounded-tl-2" : index === data.length - 1 ? "rounded-tr-2 border-none" : ""
            } cursor-pointer flex-auto px-4 h-30 flex justify-center items-center border-0 border-r-1 border-solid border-[#EAEFFF] -mt-1`}
            key={index}
            onClick={() => {
              setActive(index);
              setId(item.relationChartId);
            }}
          >
            {item.title}
          </p>
        ))}
      </div>
      <p className='text-[#999999] text-12 ml-8 mt-10'>注:視野測試均採用8891標準測試坐姿</p>
      <img src={data[active]?.values as string} alt='' className='w-270 h-200' />

      {tableData && <FixedTable dataSource={tableData} />}
    </div>
  );
};

export default ViewTestTab;
